import { loadView } from '@/helper/utils'
import { lpLayout } from '@/components/layouts/Lp'

export default {
  path: '/page/lp',
  component: lpLayout(loadView('page/Page')),
  children: [
    {
      path: 'preview/:code',
      name: 'PageLpPreview',
      component: lpLayout(loadView('page/preview/PageLpPreview'))
    }
  ]
}
